import { IWPLink } from "@/src/types";
import React from "react";

import S from "./CardGrid.styled";
import { Link } from "gatsby";

export interface Props {
  title: string;
  cards: {
    title: string;
    text: string;
    link: IWPLink;
  }[];
  extraText: string;
}

const CardGrid: React.FC<Props> = ({ title, cards, extraText }) => {
  return (
    <section className="md:mx-auto md:max-w-7xl">
      <h3
        data-aos="fade-down"
        data-aos-duration="500"
        className="text-3xl text-center py-6 md:pb-6 pb-0"
      >
        {title && title}
      </h3>

      <div
        id="valkommen"
        className="md:mx-auto md:max-w-7xl pt-0 md:pt-12 pb-24"
      >
        <S.GridContainer className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {cards.map((card, idx) => (
            <>
            {card?.link?.url && card?.link?.title && 
              <Link
                to={card.link.url}
                key={idx}
                data-aos="fade-down"
                data-aos-duration={1000}
                className="cursor-pointer info-card shadow-md transition-shadow duration-400 ease-in-out hover:shadow-2xl m-4 py-12 px-12 whitespace-no-wrap flex flex-col justify-between items-center justify-center rounded-md text-center"
              >
                <h4 className="mt-2 text-2xl">{card.title}</h4>
                <div
                  className=""
                  dangerouslySetInnerHTML={{ __html: card.text }}
                ></div>
                <Link to={card.link.url}>
                  <div className="mt-6 mr-2 flex items-center justify-between text-base font-medium rounded-full text-white bg-metlab-500 transition duration-200 ease-in-out hover:bg-green-600 py-4 px-6 md:">
                    {card.link.title}
                  </div>
                </Link>
              </Link>
            }
            </>
          ))}
        </S.GridContainer>

        <p
          className="text-center md:mx-auto md:max-w-7xl pt-12"
          dangerouslySetInnerHTML={{ __html: extraText }}
        />
      </div>
    </section>
  );
};

export default CardGrid;
